import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linear-background card",
  style: {"min-height":"100%"}
}
const _hoisted_2 = {
  key: 1,
  class: "card card-xxl-stretch"
}
const _hoisted_3 = { class: "d-flex flex-stack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Registered Trades Summary", -1)
const _hoisted_5 = { class: "ms-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "Total Value of Registered Trades", -1)
const _hoisted_9 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_10 = { class: "card-body p-0" }
const _hoisted_11 = { class: "card-px mt-n20 position-relative" }
const _hoisted_12 = { class: "row m-0" }
const _hoisted_13 = { class: "col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2" }
const _hoisted_16 = { class: "ms-4 text-warning fw-bold fs-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { class: "text-warning fw-bold fs-6" }, "Total Number of Registered Trades ", -1)
const _hoisted_18 = { class: "col bg-light-success px-6 py-8 rounded-2 mb-7" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2" }
const _hoisted_21 = { class: "ms-4 text-success fw-bold fs-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-success fw-bold fs-6"
}, " Max total number Registered Trade", -1)
const _hoisted_23 = { class: "row m-0" }
const _hoisted_24 = { class: "col bg-light-danger px-6 py-8 rounded-2 me-7" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2" }
const _hoisted_27 = { class: "ms-4 text-danger fw-bold fs-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-danger fw-bold fs-6 mt-2"
}, "min number of Registered Trade", -1)
const _hoisted_29 = { class: "col bg-light-primary px-6 py-8 rounded-2" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2" }
const _hoisted_32 = { class: "ms-4 text-primary fw-bold fs-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-primary fw-bold fs-6 mt-2"
}, " avg number of Registered Trades ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_RegisteredTradesFilterWidgets = _resolveComponent("RegisteredTradesFilterWidgets")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([`bg-${_ctx.widgetColor}`, "px-9 pt-7 card-rounded h-275px w-100"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass([`btn-active-color-${_ctx.widgetColor}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-placement": "bottom-end",
                  "data-kt-menu-flip": "top-end"
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                  ])
                ], 2),
                _createVNode(_component_RegisteredTradesFilterWidgets, {
                  onFilterSelected: _ctx.onTypeChange,
                  onReset: _ctx.onReset
                }, null, 8, ["onFilterSelected", "onReset"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.data.totalValue), 1)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.data.data.count), 1)
                  ]),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr045.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.data.data.max), 1)
                  ]),
                  _hoisted_22
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr044.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.data.data.min), 1)
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr042.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.data.data.avg), 1)
                  ]),
                  _hoisted_33
                ])
              ])
            ])
          ]),
          _createVNode(_component_apexchart, {
            class: "mixed-widget-6-chart card-rounded-bottom",
            options: _ctx.chartOptions,
            series: _ctx.series,
            height: _ctx.chartHeight,
            type: "area"
          }, null, 8, ["options", "series", "height"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}